export enum ButtonSize {
  small,
  semiSmall,
  medium,
  semiLarge,
  large,
}
